import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Link as RRDLink } from "react-router-dom";
import { Link as MuiLink } from "@material-ui/core";

export const WrappedLinkRouter = forwardRef((props, ref) => (
  <RRDLink innerRef={undefined} {...props} /> 
  
));
WrappedLinkRouter.displayName = "WrappedLinkRouter";

const WrappedLink = ({
  children,
  to = "/",
  external = false,
  underline = "none",
  url = null,
  ...props
}) => (
  <MuiLink
    underline={underline}
    component={url !== null ? undefined : WrappedLinkRouter} 
    rel="noreferrer"
    target={external ? "_blank" : "_self"}
    to={url !== null ? undefined : to} 
    href={url !== null ? url : undefined}
    {...props}
  >
    {children}
  </MuiLink>
);

WrappedLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func])
    .isRequired,
  className: PropTypes.string,
  external: PropTypes.bool
};

export default WrappedLink;
